// Landing page content data

export const eventInfo = {
  name: "The Reset",
  tagline: "Black Men's Wellness Retreat",
  dates: "July 23-26, 2026",
  daysFormat: "Thu-Sun",
  location: "Panama City, Panama",
  venue: "The Westin Playa Bonita",
  price: 1500,
  paymentPlanAmount: 500,
  totalSpots: 25,
  spotsRemaining: 6,
  eventDate: new Date('2026-07-23T09:00:00')
};

export const heroContent = {
  headline: "Rise as Kings. Build Legacy.",
  subheadline: "A transformative 4-day, 3-night retreat for Black men to replenish, connect, and gain tools for personal, professional, and spiritual growth.",
  ctaPrimary: "Secure Your Spot",
  ctaSecondary: "Learn More"
};

export const brotherhoodContent = {
  title: "What Is Brotherhood?",
  paragraphs: [
    "Brotherhood is more than friendship—it's a sacred bond built on shared experiences, mutual respect, and collective growth. For Black men, brotherhood is essential to navigate a world that often seeks to divide and isolate us.",
    "In brotherhood, we find strength in numbers, wisdom in shared stories, and healing in authentic connection. We create spaces where vulnerability is not weakness, where seeking support is courage, and where lifting each other up becomes our collective purpose.",
    "This retreat is about building that brotherhood—creating lasting connections that extend beyond these four days, forming a network of support that strengthens us all as we build our legacies and shape our futures."
  ]
};

export const whyPanama = {
  title: "Why Panama City, Panama?",
  reasons: [
    {
      title: "Rich Cultural Heritage",
      description: "A vibrant blend of indigenous, African, and Latin American cultures that honors our diverse roots"
    },
    {
      title: "Beautiful Location",
      description: "Stunning beaches and tropical landscapes provide the perfect backdrop for reflection and renewal"
    },
    {
      title: "Serenity & Peace",
      description: "A tranquil setting away from daily distractions, allowing deep introspection and authentic connection"
    },
    {
      title: "Access to City",
      description: "Close proximity to Panama City's vibrant culture, history, and the iconic Panama Canal"
    }
  ]
};

export const benefits = [
  { title: "Replenish & Recharge", description: "Feel truly restored through intentional rest and rejuvenation in a supportive environment." },
  { title: "Vulnerability as Strength", description: "Discover the power of authentic connection and understand that opening up is a form of courage." },
  { title: "Practical Coping Tools", description: "Gain actionable strategies to manage personal and professional stress effectively." },
  { title: "Build Confidence", description: "Cultivate unshakeable confidence in yourself, your family, and your relationships." },
  { title: "Strengthen Decision-Making", description: "Enhance your ability to make powerful decisions across all areas of life." },
  { title: "Mental Clarity Practices", description: "Learn meditation and mental cleansing techniques you can practice long after the retreat." },
  { title: "Counter Systemic Pressures", description: "Build sustainable mindsets to navigate and overcome racism and societal challenges." },
  { title: "Partnership Excellence", description: "Develop skills to strengthen romantic, family, and business partnerships." },
  { title: "Ancestral Connection", description: "Reconnect with your roots and honor the legacy of those who came before you." }
];

export const speakers = [
  {
    name: "David Harper",
    role: "Breakout Facilitator",
    credentials: "Wealth Management Expert",
    bio: "Co-founder of Matters of the Mind Vaultage. Successful entrepreneur, real estate developer, and investor empowering communities to build generational wealth.",
    image: "https://customer-assets.emergentagent.com/job_blackmens-wellness/artifacts/vez740xp_image.jpeg"
  },
  {
    name: "Neil Alvanzo",
    role: "Breakout Facilitator",
    credentials: "Certified Life Coach",
    bio: "Certified life and leadership coach with a heart for Black men. Podcast leader and national speaker dedicated to helping Black men find their most authentic selves.",
    image: "https://customer-assets.emergentagent.com/job_growth-sanctuary-1/artifacts/vdjqv0iy_professional_pic.jpg"
  },
  {
    name: "David Girton",
    role: "Wellness Coach",
    credentials: "The HEALth Debt Coach™",
    bio: "Wellness coach, speaker, and founder of LiveNow Fitness. Helps men reconnect with their bodies and reclaim energy through sustainable self-care.",
    image: "https://customer-assets.emergentagent.com/job_growth-sanctuary-1/artifacts/ne6a1p30_DavidTheHDC-bio-pic.jpg"
  },
  {
    name: "DeWayne Ellis",
    role: "Wealth Strategist",
    credentials: "Founder & Managing Partner, The Wealth Syndicate LLC",
    bio: "Financial strategist with over 20 years of experience in financial services, managing more than $50 million in client portfolios. Specializes in financial and insurance planning, helping individuals and businesses consistently exceed their investment goals.",
    image: "https://customer-assets.emergentagent.com/job_analytics-live-1/artifacts/6ux45b0w_DeWayne_Ellis.png"
  }
];

export const schedule = [
  {
    day: 1,
    title: "Thursday: Arrival & Welcome",
    subtitle: "Setting the Sacred Space",
    time: "Arrive before 9:00 PM",
    activities: [
      "Check-in and room assignments",
      "Welcome dinner and orientation",
      "Opening circle and intention setting",
      "Evening meditation and rest"
    ]
  },
  {
    day: 2,
    title: "Friday: Foundation & Deep Work",
    subtitle: "Building the Brotherhood",
    time: "Full Day",
    activities: [
      "Morning wellness practice",
      "Keynote: Leadership & Mental Health",
      "MasterMind Session: Wealth, Purpose & Legacy",
      "Breakout sessions on wealth & purpose",
      "Brotherhood bonding activities",
      "Evening reflection circle"
    ]
  },
  {
    day: 3,
    title: "Saturday: Exploration & Integration",
    subtitle: "Building Legacy, Taking It Home",
    time: "Full Day",
    activities: [
      "Sunrise beach meditation",
      "MasterMind Session: Partnerships, Decision-Making & Integration",
      "Workshops on partnerships & decision-making",
      "Panama Canal excursion (optional)",
      "Integration sessions",
      "Celebration dinner"
    ]
  },
  {
    day: 4,
    title: "Sunday: Commitment & Departure",
    subtitle: "Taking It Home",
    time: "Check-out by 2:00 PM",
    activities: [
      "Final morning practice",
      "Commitment ceremonies",
      "Brotherhood pledges",
      "Departure and continued connection"
    ]
  }
];

export const venue = {
  name: "The Westin Playa Bonita",
  location: "Panama City, Panama",
  distance: "30 minutes from Tocumen International Airport (PTY)",
  website: "https://www.marriott.com/search/availabilityCalendar.mi?isRateCalendar=true&propertyCode=PTYBW&isSearch=true&currency=&costTab=total&isAdultsOnly=false#/0/",
  amenities: [
    "Luxurious oceanfront rooms with modern amenities",
    "Private balconies with stunning Pacific views",
    "World-class spa and fitness facilities",
    "Multiple restaurants and bars on-site",
    "Direct beach access for relaxation and wellness activities",
    "Full-service resort with pool, gardens, and meeting spaces"
  ],
  included: [
    "4 days / 3 nights accommodation",
    "All meals and refreshments",
    "Workshop materials",
    "Airport shuttle service"
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Marcus Johnson",
    title: "Executive Director, Tech Industry",
    location: "Atlanta, GA",
    quote: "This retreat was the reset I didn't know I needed. I came in carrying the weight of corporate America and left with tools to lead authentically. The brotherhood I found here is irreplaceable.",
    rating: 5
  },
  {
    id: 2,
    name: "Terrence Williams",
    title: "Entrepreneur & Father of 3",
    location: "Houston, TX",
    quote: "For the first time in years, I allowed myself to be vulnerable among other Black men. The experience transformed how I show up for my family and business. Worth every penny.",
    rating: 5
  },
  {
    id: 3,
    name: "Dr. Kevin Mitchell",
    title: "Physician",
    location: "Chicago, IL",
    quote: "As a doctor, I'm always caring for others. This retreat taught me to care for myself without guilt. The Panama setting was perfect for healing and reflection.",
    rating: 5
  },
  {
    id: 4,
    name: "James Thompson",
    title: "Senior Pastor",
    location: "Dallas, TX",
    quote: "The spiritual grounding combined with practical tools made this unlike any retreat I've attended. I returned home with renewed purpose and a network of brothers for life.",
    rating: 5
  }
];

export const faqs = [
  {
    question: "What's included in the $1,500 registration?",
    answer: "Your registration includes 4 days/3 nights accommodation at The Westin Playa Bonita, all meals and refreshments, workshop materials, airport shuttle service, and access to all retreat activities and sessions."
  },
  {
    question: "Is there a payment plan available?",
    answer: "Yes! We offer a 3-part payment plan of $500 per month. You can select this option during checkout."
  },
  {
    question: "What is the cancellation policy?",
    answer: "All cancellations are subject to a 25% cancellation fee. No refunds will be issued after May 1, 2026. Cancellations must be submitted in writing to askcoachneil@gmail.com."
  },
  {
    question: "What should I bring?",
    answer: "Comfortable clothing for workshops and activities, swimwear, sunscreen, a journal, and an open heart ready for transformation. A detailed packing list will be sent after registration."
  },
  {
    question: "Is this retreat suitable for first-timers?",
    answer: "Absolutely! This retreat is designed for Black men at all stages of their wellness journey. Whether you're new to retreats or a seasoned participant, you'll find value and brotherhood here."
  }
];
